import type { Nullable } from '@src/shared/types/common';

type CommentsMap = Record<string, string>;

function getStoredComments(): Nullable<CommentsMap> {
    return JSON.parse(localStorage.getItem('comments') ?? 'null');
}

const LocalComments = {
    getComment(ticketId: string): Nullable<string> {
        const comments = getStoredComments();
        return comments ? comments[ticketId] ?? null : null;
    },

    saveComment(ticketId: string, comment: string): void {
        const existing = getStoredComments();
        const comments: CommentsMap = existing
            ? { ...existing, [ticketId]: comment }
            : { [ticketId]: comment };

        localStorage.setItem('comments', JSON.stringify(comments));
    },

    deleteComment(ticketId: string): void {
        const comments = getStoredComments();

        if (comments?.[ticketId]) {
            const { [ticketId]: _removed, ...rest } = comments;
            localStorage.setItem('comments', JSON.stringify(rest));
        }
    }
};

window.LocalComments = LocalComments;
